import { DayOfWeek, RecurrenceType } from "@clockwise/schema";
import { Duration } from "luxon";

export type FlexMeeting = {
  conflicted?: boolean;
  duration?: Duration;
  editable?: boolean;
  flexible?: boolean;
  restricted?: boolean;
  id: string;
  recurrence: RecurrenceType | null;
  recurrenceText?: string;
  title: string;
  flexType?: {
    dayOfWeek: DayOfWeek[];
    type: "Day" | "Week" | "AllowedDays";
  };
};

export type FlexMeetingEventMap = Record<string, FlexMeeting>;

export const getFlexMeetingMapFromSuggestionList = (suggestions: FlexMeeting[]) => {
  let flexMeetingMap: FlexMeetingEventMap = {};

  suggestions.forEach((suggestion) => {
    flexMeetingMap[suggestion.id] = suggestion;
  });

  return flexMeetingMap;
};
export const getEventListFromFlexMeetingMap = (eventMap: FlexMeetingEventMap) => {
  return Object.keys(eventMap).map((key) => eventMap[key]);
};
